export default "__VITE_ASSET__a4a61daa__"